import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./../../components/Header";
import { useDispatch, useSelector } from "react-redux";

import {
  allAdmins,
  updateAdmin,
  filterClientes,
  loginSessionAdminIn,
  sessionLogOut,
} from "../../store/modules/admin/actions";

var tokenAuto = sessionStorage.getItem("token");
var SesId = sessionStorage.getItem("id");
var SesNome = sessionStorage.getItem("name");
var SesEmail = sessionStorage.getItem("email");
var SesAtive = sessionStorage.getItem("active");

export default function CheckOut() {
  const {
    behavior,
    form,
    components,
    code,
    auth,
    carros_Alugados,
    carro_Alugado,
  } = useSelector((state) => state.admin);

  const { cliente } = useSelector((state) => state.cliente);
  const {
    reservations,
    reserva,
    carrosDisponivel,
    reservaCarrosCliente,
    vehicles,
    reservations_details,
  } = useSelector((state) => state.reserva);

  const dispatch = useDispatch();
  const navigate = useNavigate();

 
const voltar= ()=>{
    navigate("/admin")
} 


  const logOut = () => {
    dispatch(sessionLogOut());
    navigate("/");
  };

  return (
    <div className=" d-flex  flex-column col-12 col-sd-12 col-md-12 col-xl-12 w-100 p-0 m-0">
      <div
        className="d-flex  flex-row   col-12 col-sd-12 col-md-12 col-xl-12 "
     
      >
        <Header name={SesNome} email={SesEmail} />
      </div>
      <div>CheckOut</div>

      <form>
        <div className="form-group col-12 col-sd-12 col-md-12 col-xl-12 w-100 p-1 m-0">
          <b>Reserva</b>
          <input
            disabled={true}
            type="text"
            className="form-control"
            placeholder="id da reserva"
            value={reservations_details.id}
            onChange={(e) => []}
          />
        </div>
        <div className="form-group col-12 col-sd-12 col-md-12 col-xl-12 w-100 p-1 m-0">
          <b>Odometro inicial</b>

          <input
            disabled={false}
            type="text"
            className="form-control"
            placeholder="Odometro inicial"
            value={reservations_details.start_odometer}
            onChange={(e) => []}
          />
        </div>
        <div className="form-group col-12 col-sd-12 col-md-12 col-xl-12 w-100 p-1 m-0">
          <b>Odometro final</b>

          <input
            disabled={true}
            type="text"
            className="form-control"
            placeholder="Odometro final"
            value={reservations_details.end_odometer}
            onChange={(e) => []}
          />
        </div>

        <div className=" container m-1 ">
        <div className=" row row-cols-2 row-cols-lg-5 g-2 g-lg-3">

        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id="flexCheckDefault"
          />
          <label className="form-check-label" for="flexCheckDefault">
          Extintor
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id="flexCheckDefault"
          />
          <label className="form-check-label" for="flexCheckDefault">
          Macaco hidraulico
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id="flexCheckDefault"
          />
          <label className="form-check-label" for="flexCheckDefault">
          Triângulo
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id="flexCheckDefault"
          />
          <label className="form-check-label" for="flexCheckDefault">
            Chave de roda
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id="flexCheckDefault"
          />
          <label className="form-check-label" for="flexCheckDefault">
            Estrutura 
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id="flexCheckDefault"
            />
          <label className="form-check-label" for="flexCheckDefault">
            Pintura 
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id="flexCheckDefault"
            />
          <label className="form-check-label" for="flexCheckDefault">
          steppe 
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            value=""
            id="flexCheckDefault"
            />
          <label className="form-check-label" for="flexCheckDefault">
          Documentos 
          </label>
        </div>
  
            </div>
            </div>
        <div className="form-group col-12 col-sd-12 col-md-12 col-xl-12 w-100 p-1 m-0">
          <b>Detalhes</b>

          <textarea className="form-control col-12 col-sd-12 col-md-12 col-xl-12 w-100 p-0 m-0" aria-label="With textarea">

          </textarea>
        </div>
        <div className="form-group col-12 col-sd-12 col-md-12 col-xl-12 w-100 ">
          <b>Frente do Carro</b>
          <input
            
            type="file"
            accept="image/png, image/gif, image/jpeg" 
            capture="camera"     
            value={reservations_details.id}
            onChange={(e) => []}
          />
        </div>
        <div className="form-group col-12 col-sd-12 col-md-12 col-xl-12 w-100 ">
          <b>Lateral direita</b>
          <input
            
            type="file"
            accept="image/png, image/gif, image/jpeg" 
            capture="camera"     
            value={reservations_details.id}
            onChange={(e) => []}
          />
        </div>
        <div className="form-group col-12 col-sd-12 col-md-12 col-xl-12 w-100 ">
          <b>Traceira do Carro</b>
          <input
            
            type="file"
            accept="image/png, image/gif, image/jpeg" 
            capture="camera"     
            value={reservations_details.id}
            onChange={(e) => []}
          />
        </div>
        <div className="form-group col-12 col-sd-12 col-md-12 col-xl-12 w-100 ">
          <b>Lateral esquerda</b>
          <input
            
            type="file"
            accept="image/png, image/gif, image/jpeg" 
            capture="camera"     
            value={reservations_details.id}
            onChange={(e) => []}
          />
        </div>
        <div className=" d-flex  flex-row  justify-content-between mt-2 ">

        <button type="submit  " className="btn btn-success"> Liverar Carro</button>
        <button type="submit  " className="btn btn-primary" onClick={voltar}> voltar</button>
        </div>
      </form>
    </div>
  );
}
